import React, { useEffect } from "react";
import { Chip } from "@material-ui/core";

function FilterSelectionComponent(props: any) {
  const forceUpdate = React.useReducer(() => ({}), {})[1] as () => void;
  const [filters, setFilters] = React.useState(props.filters);

  function handleSelectionFilter(item: any, index: any) {
    let currentFilters = filters;
    let currentFilter = currentFilters[index];
    currentFilter.selected = true;
    currentFilters.map((mObj: any) => {
      if (mObj.title !== item.title) {
        mObj.selected = false;
      }
      return null;
    });
    currentFilters.splice(index, 1, currentFilter);
    props.onSelectedFilter(currentFilter);
    setFilters(currentFilters);
    forceUpdate();
  }

  useEffect(() => {
    setFilters(props.filters);
    forceUpdate();
  }, [props.filters, forceUpdate]);
  return (
    <div style={{ flexDirection: "row" }}>
      {filters.map((item: any, index: any) => {
        return (
          <Chip
            key={`item-key-chip-filter-${index.toString()}`}
            size="small"
            label={item.title}
            variant={"outlined"}
            clickable
            onClick={() => handleSelectionFilter(item, index)}
            style={{
              margin: 10,
              borderColor: item.selected ? "white" : "grey",
              borderWidth: 1,
              color: item.selected ? "white" : "black",
              backgroundColor: item.selected ? "#0071EB" : "white",
            }}
          />
        );
      })}
    </div>
  );
}

export default FilterSelectionComponent;
